import React, {useState} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import IdentityVerification from "./IdentityVerification";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as GroupGameService from "../../api/GroupGameService"
import GroupGameViewMentor from "./GroupGameViewMentor";
import GroupGameNotFound from "./GroupGameNotFound";
import InstagramWarning from "../InstagramWarning";

export default function GroupGameContainer() {

    const params = useParams()
    const [queryParams] = useSearchParams()

    const [identityVerified, setIdentityVerified] = useState()
    const [gameState, setGameState] = useState()
    const [gameFetchFailed, setGameFetchFailed] = useState(undefined)

    function getCurrentPlayerData(gameState, playerId) {
        for (const player of gameState?.players) {
            if (player.id === playerId) {
                return player
            }
        }
    }

    function callGameState() {
        GroupGameService.getGroupGame(params.id, queryParams.get("player"),
            (state) => {
                setGameState(state)
                if (state.role === "mentor") {
                    setIdentityVerified(true)
                } else {
                    const currentPlayer = getCurrentPlayerData(state, queryParams.get("player"))
                    setIdentityVerified(currentPlayer.identity_verified)
                }
            },
            (response) => {
                if (response.status === 301) {
                    response.json().then((data) => {
                        if (data["new_player_id"]) {
                            window.open(`/groupgame/${data["new_game_id"]}?player=${data["new_player_id"]}`, "_self")
                        } else {
                            window.open(`/groupgame/${data["new_game_id"]}`, "_self")
                        }
                    })
                } else {
                    setGameFetchFailed(true)
                }
            })
    }

    useEffectOnce(() => {
        callGameState()
    })


    return (
        <>
            <InstagramWarning/>
            {gameFetchFailed === true && <GroupGameNotFound callGameState={callGameState}/>}
            {identityVerified === false && <IdentityVerification
                gameState={gameState}
                currentPlayer={getCurrentPlayerData(gameState, queryParams.get("player"))}
                callGameState={callGameState}
            />}
            {identityVerified === true && <GroupGameViewMentor/>}
        </>
    )

}